export default () => ({
    user: {},
    attributeOptions: [],
    education: [],
    reference: [],
    workExperience: [],
    workLocations: [],
    desiredOccupations: [],
    savedJobAlerts: [],
    resumes: [],
    coverLettersCreate: [],
    coverLetters: [],
    additionalDocuments: [],
    guestResume: {},
    jobEvents: [],
    saveJobAfterLogin: '',
    isSearchSaveModalOpen: false,
});
